import React, { useState } from 'react';
import Card from 'src/common/refactoredComponents/card/Card';
import BundleTag from 'src/common/components/orderDetails/bundleTag/BundleTag';
import SubItemDatatable from '../detailsDataTable/subItemsDatatable/SubItemsDatatable';
import CfnLabel from 'src/common/components/orderDetails/bundleCards/CfnLabel';
import SerialNoLabel from 'src/common/components/orderDetails/bundleCards/SerialNoLabel';
import ItemDescriptionLabel from 'src/common/components/orderDetails/bundleCards/ItemDescriptionLabel';
import QuantityContainer from 'src/common/components/orderDetails/bundleCards/QuantityContiner';
import PricingContainer from 'src/common/components/orderDetails/bundleCards/PricingContainer';
import BundleLayout from 'src/common/components/orderDetails/bundleCards/BundleLayout';
import {
    UsagePricingContainer,
    UsagePricingDataContainer,
    UsagePriceFont,
    UsagePricingFullWidth,
    Discount,
} from './BundleCards.styled';
import PoInfoView from 'src/pages/orders/components/orderDetails/billingSummary/PoInfoView';
import { useTranslation } from 'react-i18next';

const BundleCards = ({
    setDetailsData,
    setItemHandler,
    keyIndex,
    isBundle,
    cfn,
    quantity,
    uom,
    isUsed,
    serialNo,
    description,
    poNumber,
    unitPrice,
    subUnitPrice,
    extPrice,
    subExtPrice,
    discount,
    subItemsData,
    subItemsColumns,
    descriptionMobileFontSize,
    isAccountOwned,
    isNotBilled,
    orderType,
    isDiscount,
    isAttachment,
    hidePricing,
}) => {
    const [showBundleSubItems, setShowBundleSubItems] = useState(false);

    const showBundleSubItemsHandler = () => {
        setShowBundleSubItems(!showBundleSubItems);
    };
    const { t } = useTranslation();
    return (
        <Card
            key={keyIndex}
            border={
                isAccountOwned || isNotBilled ? 'none' : '1px solid #74DED6'
            }
            padding={'10px'}
            width={isAccountOwned || isNotBilled ? '98%' : undefined}
            margin={'10px 0 0 0'}
        >
            <UsagePricingContainer>
                <BundleLayout
                    isExpand={showBundleSubItems ? true : false}
                    bundleClickHandler={showBundleSubItemsHandler}
                    isShowBundleSubItem={showBundleSubItems}
                    isBundle={isBundle && subItemsData.length > 0}
                >
                    <UsagePricingFullWidth>
                        <UsagePricingDataContainer
                            alignItems={'center'}
                            justifyContent={'flex-start'}
                            width={isBundle ? '70%' : '50%'}
                        >
                            <CfnLabel
                                cfnFontColor={isBundle && '#140F4B'}
                                setItemHandler={setItemHandler}
                                setDetailsData={setDetailsData}
                                cfn={cfn}
                                isShowSetItemDetails={!isBundle ? true : false}
                                cursor={'pointer'}
                            />
                            {isBundle ? (
                                <BundleTag
                                    bundleFontOpacity={'0.92'}
                                    value={'Bundle'}
                                />
                            ) : null}
                        </UsagePricingDataContainer>
                        <UsagePricingDataContainer
                            margin={'0'}
                            width={isBundle ? '30%' : '50%'}
                        >
                            <QuantityContainer
                                quantity={quantity}
                                isUsed={isUsed}
                                uom={uom}
                                isShowUom={!isBundle ? true : false}
                                alignItems={'center'}
                                showLabel={true}
                                orderType={orderType}
                            />
                        </UsagePricingDataContainer>
                    </UsagePricingFullWidth>
                    <UsagePricingFullWidth>
                        {serialNo ? (
                            <SerialNoLabel
                                serialNo={serialNo}
                                showLabel
                                marginContainer={'0 0 5px 0'}
                            />
                        ) : null}
                    </UsagePricingFullWidth>
                    <UsagePricingFullWidth>
                        <ItemDescriptionLabel
                            lineHeight={'19px'}
                            letterSpacing={'-0.1px'}
                            description={description}
                            mobileFontSize={descriptionMobileFontSize}
                        />
                    </UsagePricingFullWidth>
                    {!isAccountOwned && !isNotBilled ? (
                        <UsagePricingFullWidth>
                            <UsagePricingDataContainer
                                flexDirection={'column'}
                                width={'40%'}
                                margin={'0 0 5px 0'}
                                alignItems={'flex-start'}
                            >
                                {poNumber ? (
                                    <>
                                        <div
                                            style={{
                                                display: 'flex',
                                                marginLeft: isAttachment
                                                    ? '-5px'
                                                    : '',
                                            }}
                                        >
                                            {orderType ===
                                                t(
                                                    'consignmentReturn.submit.ke'
                                                ) && isAttachment ? (
                                                <PoInfoView
                                                    isAttachment={isAttachment}
                                                />
                                            ) : null}
                                            <UsagePriceFont
                                                color="#202124"
                                                fontFamily="AvenirNextWorld Demi"
                                                margin={'0 0 5px 0'}
                                            >
                                                {orderType ===
                                                t('consignmentReturn.submit.ke')
                                                    ? t(
                                                          'consignmentReturn.submit.po'
                                                      )
                                                    : t(
                                                          'consignmentReturn.submit.pO'
                                                      )}
                                            </UsagePriceFont>
                                        </div>
                                        <UsagePriceFont className="common-po-number-dt-mask"
                                            color="#202124"
                                            fontSize="14px"
                                            textAlign={
                                                orderType ===
                                                    t(
                                                        'consignmentReturn.submit.ke'
                                                    ) ||
                                                orderType ===
                                                    t(
                                                        'consignmentReturn.submit.zlb'
                                                    )
                                                    ? 'left'
                                                    : null
                                            }
                                        >
                                            {poNumber ? poNumber : null}
                                        </UsagePriceFont>
                                    </>
                                ) : null}

                                {discount ? (
                                    isDiscount !== undefined && !isDiscount ? (
                                        <Discount>
                                            {discount}
                                            {t('common.increase')}
                                        </Discount>
                                    ) : (
                                        <Discount>
                                            {discount}
                                            {t('common.discount')}
                                        </Discount>
                                    )
                                ) : null}
                            </UsagePricingDataContainer>

                            {!hidePricing ? (
                                <>
                                    <UsagePricingDataContainer width={'30%'}>
                                        <PricingContainer
                                            pricingLabel={t(
                                                'orders.orderDetails.orderDetailTab.extrasOrderDetail.Bundle.unitPrice'
                                            )}
                                            price={unitPrice}
                                            subPrice={subUnitPrice}
                                        />
                                    </UsagePricingDataContainer>
                                    <UsagePricingDataContainer width={'30%'}>
                                        <PricingContainer
                                            pricingLabel={t(
                                                'orders.orderDetails.orderDetailTab.extrasOrderDetail.Bundle.extPrice'
                                            )}
                                            price={extPrice}
                                            subPrice={subExtPrice}
                                        />
                                    </UsagePricingDataContainer>
                                </>
                            ) : null}
                        </UsagePricingFullWidth>
                    ) : null}
                    {isAccountOwned || isNotBilled ? (
                        <UsagePricingFullWidth>
                            <UsagePricingDataContainer
                                flexDirection={'column'}
                                width={'100%'}
                                margin={'0 0 5px 0'}
                                alignItems={'flex-end'}
                                justifyContent={'flex-end'}
                            >
                                <UsagePriceFont
                                    fontFamily={'AvenirNextWorld Demi'}
                                    color="#989898"
                                    fontSize="12px"
                                    lineHeight={'21px'}
                                >
                                    {t(
                                        'reportUsage.record.reportPayment.ItemList.ItemListRPView.accountOwned'
                                    )}
                                </UsagePriceFont>
                            </UsagePricingDataContainer>
                        </UsagePricingFullWidth>
                    ) : null}
                </BundleLayout>

                {showBundleSubItems ? (
                    <UsagePricingFullWidth>
                        <SubItemDatatable
                            colDatas={subItemsColumns}
                            rowDatas={subItemsData}
                            setItemHandler={setItemHandler}
                            textAlign={'left'}
                        />
                    </UsagePricingFullWidth>
                ) : null}
            </UsagePricingContainer>
        </Card>
    );
};

export default BundleCards;
